// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724663203388/c1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724663203783/d1.jpg',
    },
    NA: {
        pc: '',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725155341200/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725155340495/euH1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725162852847/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725162851923/ukH1.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736750480271/LFP.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736905844495/LFP.jpg',
    },
};
const imgLocale: any = {
    jp: imgAllA.JP,
    us: imgAllA.JP,
    ca: imgAllA.JP,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    au: imgAllA.AU,
};
export default imgLocale;
